import { FiCopy as _FiCopy } from "@react-icons/all-files/fi/FiCopy.js";
import React from 'react';
import Text from 'core/components/Text';
import Button from 'core/components/Button';
import Tooltip from 'core/components/Tooltip';
import CopyToClipboardButton from 'app/components/CopyToClipboardButton';
const IdTag = ({
  id,
  small = false,
  copyable = true,
  intent = 'none',
  isExport = false
}) => {
  if (id == null || isExport) {
    return id ?? null;
  }
  const strId = String(id);
  const displayId = strId.length > 17 ? `${strId.slice(0, 4)}…${strId.slice(-12)}` : strId;
  const text = /*#__PURE__*/React.createElement(Text, {
    monospace: true
  }, displayId);
  if (!copyable) {
    return text;
  }
  const COPIED = 'Copied!';
  const pad = Math.max(0, displayId.length - COPIED.length);
  const copiedText = /*#__PURE__*/React.createElement(Text, {
    monospace: true
  }, COPIED + '\u00A0'.repeat(pad)); // Pad to reduce layout shift
  const stopPropagation = e => e.stopPropagation();
  const button = /*#__PURE__*/React.createElement("div", {
    onClick: stopPropagation,
    onMouseDown: stopPropagation,
    onKeyDown: stopPropagation
  }, /*#__PURE__*/React.createElement(CopyToClipboardButton, {
    text: strId,
    copyConfirmationText: copiedText,
    intent: intent
  }, /*#__PURE__*/React.createElement(Button, {
    text: text,
    icon: _FiCopy,
    iconSize: 12,
    small: small,
    minimal: true,
    py: "3px",
    px: "6px",
    ariaLabel: "Copy ID",
    style: {
      minHeight: 'unset'
    }
  })));
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: "Copy to Clipboard"
  }, button);
};
export default IdTag;